var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"ptend_gao"},[_c('div',{staticClass:"ptend_div"},[_c('img',{attrs:{"src":require("../../../image/wu_b.png")}}),_c('p',[_vm._v(_vm._s(_vm.noTitle))]),(_vm.ifShowNoTxt)?_c('span',[_vm._v(_vm._s(_vm.noTxt))]):_vm._e()])])
}
var staticRenderFns = []

export { render, staticRenderFns }